import { Button, Col, DatePicker, Form, Input, Select } from 'antd'
import {
  OPTIONS_DEPOSIT,
  OPTIONS_PACKAGE_STATUS,
  OPTIONS_TYPE_REQUEST
} from '../../configData'
import { v4 as uuidv4 } from 'uuid'
import { removeVietnameseTones } from '../../config-func'
import { debounce } from 'lodash'
const { RangePicker } = DatePicker
const { Option } = Select

const SearchForm = ({ fetchData, handleSearch, setFilters }) => {
  const [form] = Form.useForm()

  const handleReset = debounce(() => {
    setFilters({ currentPage: 1, pageSize: 10, reset: uuidv4() })
    form.resetFields()
    // fetchData()
  }, 300)

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSearch}
      style={{ marginTop: 10 }}
      onValuesChange={(value, allValues) => {
        setFilters((prev) => ({ ...prev, ...allValues }))
      }}
    >
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '16px',
          alignItems: 'center'
        }}
      >
        <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <Form.Item label="Họ và tên/ Số điện thoại" name="textSearch">
            <Input
              placeholder="Nhập thông tin"
              onBlur={(e) => {
                form.setFields([
                  {
                    name: 'textSearch',
                    value: e.target.value?.trim()
                  }
                ])
              }}
            />
          </Form.Item>
        </div>
        <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <Form.Item label="Hình thức nạp tiền" name="payment_method">
            <Select placeholder="Chọn hình thức nạp tiền" 
            allowClear
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) => {
              const inputValue = removeVietnameseTones(input).toLowerCase();
              const optionValue = removeVietnameseTones(option?.children || '').toLowerCase();
              return optionValue.includes(inputValue);
            }}
            >
              {/* <Option value="">Tất cả</Option> */}
              {OPTIONS_DEPOSIT.map((i, idx) => {
                return (
                  <Option value={i.value} key={idx}>
                    {i.name}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
        </div>
        <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <Form.Item label="Trang thái" name="status">
            <Select placeholder="Chọn trạng thái" 
            allowClear
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) => {
              const inputValue = removeVietnameseTones(input).toLowerCase();
              const optionValue = removeVietnameseTones(option?.children || '').toLowerCase();
              return optionValue.includes(inputValue);
            }}
            >
              {/* <Option value="">Tất cả</Option> */}
              {OPTIONS_PACKAGE_STATUS.map((i, idx) => {
                return (
                  <Option value={i.value} key={idx}>
                    {i.name}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
        </div>

        <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <Form.Item label="Ngày yêu cầu" name="date">
            <RangePicker
              // value={dates}
              // onChange={(dates) => setDates(dates)}
              format="DD/MM/YYYY"
              style={{ width: '100%' }}
            />
          </Form.Item>
        </div>
        <div
          style={{
            display: 'flex',
            gap: '8px',
            justifyContent: 'flex-end',
            flex: '1 1 200px',
            minWidth: '200px'
          }}
        >
          <Button onClick={handleReset}>Đặt lại</Button>
          <Button type="primary" htmlType="submit" style={{ margin: '0 8px' }}>
            Tìm kiếm
          </Button>
        </div>
      </div>
    </Form>
  )
}

export default SearchForm
